
import {PropType} from 'vue';
import {Sort} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';

export default {
    props: {
        modelValue: {
            type: Object as PropType<Sort>,
            required: true,
        },
        list: {
            type: Array as PropType<Array<Sort>>,
            required: true,
        },
        desktopHidden: {
            type: Boolean,
            default: false
        }
    },
    emits: ['apply', 'update:modelValue'],
    methods: {
        onChecked(sort: Sort): void {
            this.$emit('update:modelValue', sort);
            this.$emit('apply', sort);
        },
    },
};
